/**
 *
 * @param {object to be encrypted} o
 * @param {string} salt
 */
export function encrypt(o, salt = "Salt Strirng") {
  o = JSON.stringify(o).split("");
  for (var i = 0, l = o.length; i < l; i++)
    if (o[i] === "{") o[i] = "}";
    else if (o[i] === "}") o[i] = "{";
  return encodeURI(salt + o.join(""));
}

export function decrypt(o, salt = "Salt Strirng") {
  o = decodeURI(o);
  if (salt && o.indexOf(salt) !== 0) return false;
  o = o.substring(salt.length).split("");
  for (var i = 0, l = o.length; i < l; i++)
    if (o[i] === "{") o[i] = "}";
    else if (o[i] === "}") o[i] = "{";
  return JSON.parse(o.join(""));
}

export function isEmailAddress(str) {
  if (str) {
    return true;
  } else {
    return false;
  }
}


export const isUrl = (str) => {
  const pattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}([/?#].*)?$/;
  return pattern.test(str.trim());
}

/**
 * To add st, nd, rd.... after index
 */

export function ordinal_suffix_of(i) {
  var j = i % 10, // To get Last Digit
    k = i % 100; // To get 2 Digits
  if (j === 1 && k !== 11) {
    return i + "st";
  }
  if (j === 2 && k !== 12) {
    return i + "nd";
  }
  if (j === 3 && k !== 13) {
    return i + "rd";
  }
  return i + "th";
}
